import $ from 'jquery';
import {SiteModal} from './modal';
import {productSection} from './product';

export class QuickShop {


  constructor(config) {
    this.default = {
      selector: '[data-quick-shop]',
      viewName: 'quick-shop',
      cache: true,
    };

    this.config = Object.assign(this.default, config);
    this._init();
  }

  open(productUrl) {
    const modal = new SiteModal();
    modal.loading(true);

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('view', this.config.viewName);

    $.get(url.toString()).done((response) => {
      modal.open(response);
      const section = productSection;
      const modalProductSection = modal.getModal();

      section.container = modalProductSection.find('[data-section-type="product"]')[0];
      section.namespace = 'quick-shop';
      section.onLoad();

      section.$container.on(`addedToCart${section.namespace}`, () => {
        modal.close();
      });
    }).fail(() => {
      modal.loading(false);
    });
  }

  _init() {
    $(document).on('click', this.config.selector, this._onClickHandler.bind(this));
  }

  _onClickHandler(e) {
    const target = e.currentTarget;
    const productUrl = target.dataset.quickShop;

    if (productUrl) {
      e.preventDefault();
      this.open(productUrl);
    }
  }
}
